import React, { useState, useEffect } from 'react';
import HamburgerMenu from './Hamburger';

function Navigation() {
    const [isMobile, setIsMobile] = useState(false);
    
    // Function to check if the current path matches the link
    const isActivePath = (path) => {
        return window.location.pathname === path;
    };

    // Function to generate className string
    const getLinkClasses = (path, baseClasses) => {
        return `${baseClasses} ${isActivePath(path) ? 'is-bold colorGreen' : ''}`.trim();
    };

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1023px)');
        setIsMobile(mediaQuery.matches);

        const handleResize = (e) => setIsMobile(e.matches);
        mediaQuery.addListener(handleResize);

        return () => mediaQuery.removeListener(handleResize);
    }, []);

    return (
        <>
            {isMobile ? (
                <HamburgerMenu />
            ) : (
                <div className="navbar" role="navigation" aria-label="main navigation">
                    <div className="navbar-brand is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center">
                        <a className="mr-4" href="/">
                            <svg width="51" height="47" viewBox="0 0 51 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.5204 12.2857C29.1845 11.2605 29.8835 16.9226 33.5218 27.7309C38.0755 22.5315 41.4974 8.90707 39.7132 2.4061C39.7798 3.62108 39.6233 5.47184 38.8611 7.35922C36.2314 6.14091 33.3021 5.4552 30.2164 5.4552C18.8455 5.4552 9.62833 14.6724 9.62833 26.0433C9.62833 26.8954 9.68492 27.7309 9.78811 28.5564C7.94733 33.2466 4.90156 38.6724 0.547607 41.1889C18.2297 32.218 14.891 13.4607 22.5204 12.289V12.2857Z" fill="#40B658"/>
                                <path d="M39.0374 0.711795C60.1015 9.9756 41.1345 41.4985 32.9359 43.1728C26.5048 44.4843 25.3498 35.2472 23.5989 29.7182C21.1622 35.3104 15.6732 43.2128 6.89539 42.8033C6.89539 42.8033 6.89539 42.8033 6.89539 42.8067C10.7633 43.3359 14.0887 42.6735 16.7484 41.5983C20.36 44.7273 25.0668 46.6247 30.2197 46.6247C41.5905 46.6247 50.8077 37.4075 50.8077 26.0399C50.8077 24.8682 50.7045 23.7232 50.5181 22.6047C51.9095 14.9121 50.6746 3.96394 39.0441 0.708466L39.0374 0.711795Z" fill="#40B658"/>
                            </svg>
                        </a>
                    </div>
                    <div className="navbar-menu is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center my-4 py-4">
                        <div className="navbar-start is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center">
                            <a 
                                href="/features" 
                                className={getLinkClasses('/features', 'mx-4')}
                            >
                                Features
                            </a>
                            <a 
                                href="/pricing" 
                                className={getLinkClasses('/pricing', 'mx-4')}
                            >
                                Pricing
                            </a>
                            <a 
                                href="/how-to" 
                                className={getLinkClasses('/how-to', 'mx-4')}
                            >
                                How to
                            </a>
                        </div>
                        <div className="navbar-end is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center">
                            <a 
                                href="/contact" 
                                className={getLinkClasses('/contact', 'is-flex is-flex-direction-row is-flex-wrap-wrap is-justify-content-space-between is-align-content-center')}
                            >
                                Contact
                            </a>
                            <a 
                                href="/sign-up" 
                                className={getLinkClasses('/sign-up', 'ml-4 button')}
                            >
                                Sign up
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Navigation;